import funcTranslateHelper from '../../../i18next/funcTranslateHelper';

export function translateSchema () {
  const schema = {
    type: 'object',
    properties: {
      name: {
        title: funcTranslateHelper('Builder:Actions:form:actionName'),
        type: 'string',
        placeholder: funcTranslateHelper('Builder:Actions:form:newOrder')
      },
      description: {
        title: funcTranslateHelper('Builder:Actions:form:description'),
        type: 'string',
        placeholder: funcTranslateHelper('Builder:Actions:form:descriptionPlaceholder')
      },
      id: {
        type: 'string'
      },
      type: {
        type: 'string',
        title: funcTranslateHelper('Builder:Actions:form:type'),
        enum: ['', 'POST', 'PUT'],
        default: '',
        enumNames: [
          funcTranslateHelper('Builder:Actions:form:chooseOption'),
          funcTranslateHelper('Builder:Actions:form:typeCreate'),
          funcTranslateHelper('Builder:Actions:form:typeEdit')
        ]
      },
      formAssetTitle: {
        title: funcTranslateHelper('Builder:Actions:form:formAssetTitle'),
        type: 'string',
        placeholder: funcTranslateHelper('Builder:Actions:form:formAssetTitlePlaceholder')
      },
      asset: {
        type: 'string',
        title: funcTranslateHelper('Builder:Actions:form:asset'),
        enum: [''],
        enumNames: ['']
      }
    },
    required: ['name', 'formAssetTitle', 'asset']
  };

  return schema;
}

export const uiSchema = {
  'ui:rootFieldId': 'form-roles',
  name: {
    'ui:field': 'TextInput',
    classNames: 'form-control-parent'
  },
  id: {
    'ui:field': 'HiddenId'
  },
  description: {
    'ui:field': 'TextInput',
    classNames: 'form-control-parent'
  },
  type: {
    'ui:field': 'Select',
    classNames: 'form-control-parent'
  },
  formAssetTitle: {
    'ui:field': 'TextInput',
    classNames: 'form-control-parent'
  },
  asset: {
    'ui:field': 'Select',
    classNames: 'form-control-parent'
  }
};
